'use client'
import Link from 'next/link'
import { cn } from 'core/utils'
import { usePathname } from 'next/navigation'
export default function Footer({ className }: { className?: string }) {
	const pathname = usePathname()
	return (
		<div
			className={cn(
				'relative grid gap-9 border-t p-[120px] text-lg text-gray-500 2xl:p-[80px] xl:p-[60px] xl:text-base md:p-12 sm:gap-6 sm:px-3 sm:py-6',
				className
			)}
		>
			<p>
				The site is currently under construction, new information coming soon. If you have any questions concerning
				potential partnership, please go to contacts section.
			</p>
			<div className="flex justify-between gap-12 xl:gap-9 sm:flex-col sm:gap-6">
				<p>© Anabion Automation Services QFZ LLC, {new Date().getFullYear()}</p>
				<div className="flex gap-6 [&>*]:underline">
					<Link href="/user-agreement" className={cn(pathname === '/user-agreement' && 'text-primary-foreground')}>
						User Agreement
					</Link>
					<Link
						href="/user-agreement/cookies"
						className={cn(pathname === '/user-agreement/cookies' && 'text-primary-foreground')}
					>
						Cookies
					</Link>
				</div>
			</div>
		</div>
	)
}
